import styles from './progressBar.module.css';
import icon from '../../assets/images/icons/location_onthemove.png';
interface ProgressBarProps {
    hasPackages: boolean;
    trackProgress?: number;
    isDeliveredElsewhere?: boolean;
    isDelivered?: boolean;
}
const ShippingProgress = ({
    hasPackages = false,
    trackProgress = 0,
    isDelivered = false,
    isDeliveredElsewhere = false,
}: ProgressBarProps) => {
    return (
        <section className={styles.container}>
            <div className={styles.total}>
                <div className={styles.dots}>
                    <div className={styles.dot} />
                    <div className={styles.dot} />
                    <div className={styles.dot} />
                    <div className={styles.dot} />
                    <div className={styles.dot} />
                    <div className={styles.dot} />
                </div>
                {hasPackages && isDeliveredElsewhere && (
                    <div>
                        <div
                            className={styles.current}
                            style={{width: trackProgress + '%'}}
                        />
                        <div className={styles.redirected} />
                        <div className={styles['regular-icon-redirected']}>
                            <img
                                alt="Voortgang"
                                className={styles.icon}
                                src={icon}
                            />
                        </div>
                    </div>
                )}

                {hasPackages && !isDeliveredElsewhere && (
                    <div
                        className={styles.current}
                        style={{
                            width:
                                (trackProgress === 0 ? 2 : trackProgress) + '%',
                        }}
                    >
                        <div
                            className={
                                isDelivered
                                    ? styles['full-icon']
                                    : styles['regular-icon']
                            }
                        >
                            <img
                                alt="Voortgang"
                                className={styles.icon}
                                src={icon}
                            />
                        </div>
                    </div>
                )}

                {!hasPackages && (
                    <div
                        className={styles.current}
                        style={{width: trackProgress + '%'}}
                    >
                        <div className={styles['regular-icon']}>
                            <img
                                alt="Voortgang"
                                className={styles.icon}
                                src={icon}
                            />
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
};

export default ShippingProgress;
